'use strict';

import React from 'react';
import { Route, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import Slider from 'react-slick';
import Select from 'react-select';
import Creatable from 'react-select/creatable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames/bind';

import { appSelectors, appOperations } from '@/state/domains/app';
import { usersOperations, usersSelectors } from '@/state/domains/users';
import { ordersSelectors, ordersOperations } from '@/state/domains/orders';
import { locationsSelectors } from '@/state/domains/locations';

import { RecipientSection } from '../';
import BadAddressDetails from '@/views/common/BadAddressDetails';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import c from '@/views/styles/common.scss';
import s from './styles.scss';
import l from '../styles.scss';

const lx = cn.bind(l);

const labVal = el => ({ label: el, value: el });

class BadAddress extends React.Component {

	constructor() {
		super();

		this.state = {
			description: {
				options: [
					'Res knows Sub',
					'Res doesn\'t know Sub',
					'Res didn\'t moved in recently',
					'Res moved in recently',
					'Sub moved out recently',
					'Sub never lived there',
					'No such address',
					'Vacant',
				].map(labVal),
				value: []
			},
			sex: null,
			skinColor: {
				options: [
					'White',
					'Brown',
					'Black',
					'Hispanic',
					'Asian',
					'Indian',
					'Middle Eastern',
					'Native American',
					'Poor lighting',
				].map(labVal),
				value: null
			},
			hairColor: {
				options: [
					'Brown',
					'Black',
					'Blonde',
					'Red',
					'White',
					'Gray',
					'Bald',
					'Hair covered',
					'Poor lighting',
				].map(labVal),
				value: null
			},
			age: {
				options: [
					'20s',
					'30s',
					'40s',
					'50s',
					'60s',
					'70s',
					'80s',
					'90s',
				].map(labVal),
				value: null
			},
			weight: {
				hun: {
					options: [
						{ label: '0', value: 0 },
						{ label: '1', value: 1 },
						{ label: '2', value: 2 },
						{ label: '3', value: 3 }
					],
					value: { label: '1', value: 1 }
				},
				ten: {
					options: [
						{ label: '00', value: 0 },
						{ label: '10', value: 1 },
						{ label: '20', value: 2 },
						{ label: '30', value: 3 },
						{ label: '40', value: 4 },
						{ label: '50', value: 5 },
						{ label: '60', value: 6 },
						{ label: '70', value: 7 },
						{ label: '80', value: 8 },
						{ label: '90', value: 9 }
					],
					value: { label: '50', value: 5 }
				}
			},
			height: {
				feet: {
					options: [
						{ label: '4', value: 4 },
						{ label: '5', value: 5 },
						{ label: '6', value: 6 }
					],
					value: { label: '5', value: 5 }
				},
				inches: {
					options: [
						{ label: '0', value: 0 },
						{ label: '1', value: 1 },
						{ label: '2', value: 2 },
						{ label: '3', value: 3 },
						{ label: '4', value: 4 },
						{ label: '5', value: 5 },
						{ label: '6', value: 6 },
						{ label: '7', value: 7 },
						{ label: '8', value: 8 },
						{ label: '9', value: 9 },
						{ label: '10', value: 10 },
						{ label: '11', value: 11 }
					],
					value: { label: '10', value: 10 }
				}
			},
			includeWeight: true,
			includeHeight: true,
			disablePrev: true,
			comp: {},
		};

		[
			'handleDescriptionChange',
			'setSex',
			'handleSkinColorChange',
			'handleHairColorChange',
			'handleAgeChange',
			'handleWeightHunChange',
			'handleWeightTenChange',
			'handleHeightFeetChange',
			'handleHeightInchesChange',
			'handleApplyBadAddressClick',
			'toggleHeightInclude',
			'toggleWeightInclude',
			'compVals',
		].forEach(fn => { this[fn] = this[fn].bind(this) });
	}

	handleDescriptionChange(selectedArr) {

		const { description } = this.state;

		const nsa = selectedArr.find(el => el.value === 'No such address');
		const vacant = selectedArr.find(el => el.value === 'Vacant');

		if (nsa || vacant) {
			description.value = nsa ? [ nsa ] : [ vacant ];
			this.setState({
				description,
				includeHeight: false,
				includeWeight: false,
			});
			this.slider.slickGoTo(7);
		} else {
			description.value = selectedArr;
			this.setState({ description });
		}
	}

	setSex(value) {

		const { sex } = this.state;
		this.setState({ sex: value });
		this.slider.slickNext();
	}

	handleSkinColorChange(selected) {

		const { skinColor } = this.state;
		skinColor.value = selected ? selected : null;
		this.setState({ skinColor });
		this.slider.slickNext();
	}

	handleHairColorChange(selected) {

		const { hairColor } = this.state;
		hairColor.value = selected ? selected : null;
		this.setState({ hairColor });
		this.slider.slickNext();
	}

	handleAgeChange(selected) {

		const { age } = this.state;
		age.value = selected ? selected : null;
		this.setState({ age });
		this.slider.slickNext();
	}

	handleWeightHunChange(selected) {

		const { weight } = this.state;
		weight.hun.value = selected;
		this.setState({ weight });
	}

	handleWeightTenChange(selected) {

		const { weight } = this.state;
		weight.ten.value = selected;
		this.setState({ weight });
		this.slider.slickNext();
	}

	handleHeightFeetChange(selected) {

		const { height } = this.state;
		height.feet.value = selected;
		this.setState({ height });
	}

	handleHeightInchesChange(selected) {

		const { height } = this.state;
		height.inches.value = selected;
		this.setState({ height });
		this.slider.slickNext();
	}
	
	toggleWeightInclude() {

		const { includeWeight } = this.state;
		this.setState({ includeWeight: !includeWeight });

		if (includeWeight) {
			this.slider.slickNext();
		}
	}

	toggleHeightInclude() {

		const { includeHeight } = this.state;
		this.setState({ includeHeight: !includeHeight });

		if (includeHeight) {
			this.slider.slickNext();
		}
	}

	compVals() {

		const {
			description,
			sex,
			skinColor,
			hairColor,
			age,
			weight,
			height,
			includeWeight,
			includeHeight
		} = this.state;

		const badAddressDetails = {
			description: description.value.map(el => el.value),
			sex,
			skinColor: skinColor.value ? skinColor.value.value : '',
			hairColor: hairColor.value ? hairColor.value.value : '',
			age: age.value ? age.value.value : '',
		};

		if (includeWeight) {
			badAddressDetails.weight = weight.hun.value.value * 100 + weight.ten.value.value * 10;
		}

		if (includeHeight) {
			badAddressDetails.height = height.feet.value.value * 12 + height.inches.value.value;
		}

		this.setState({ comp: badAddressDetails });
	}

	handleApplyBadAddressClick() {
		
		const {
			username,
			date,
			postCompleteTask,
			job,
			location,
			setActionMode
		} = this.props;

		const {
			description,
			sex,
			skinColor,
			hairColor,
			age,
			weight,
			height,
			includeWeight,
			includeHeight
		} = this.state;

		const geolocation = window.navigator.geolocation;

		const badAddressDetails = {
			description: description.value.map(el => el.value),
			sex,
			skinColor: skinColor.value ? skinColor.value.value : '',
			hairColor: hairColor.value ? hairColor.value.value : '',
			age: age.value ? age.value.value : '',
		};

		if (includeWeight) {
			badAddressDetails.weight = weight.hun.value.value * 100 + weight.ten.value.value * 10;
		}

		if (includeHeight) {
			badAddressDetails.height = height.feet.value.value * 12 + height.inches.value.value;
		}

		Object.keys(badAddressDetails).forEach(key => {
			if (!badAddressDetails[ key ]) {
				delete badAddressDetails[ key ];
			}
		});

		const completeTask = (geo = []) => postCompleteTask(
			username,
			date,
			job._id,
			location._id,
			'BAD_ADDRESS',
			{ details: badAddressDetails, geo }
		)

		geolocation.getCurrentPosition(
			pos => {
				const { coords } = pos;
				const { latitude, longitude } = coords;
				const geo = [ latitude, longitude ];

				completeTask(geo);
				setActionMode('select')
			},
			err => {
				completeTask();
				setActionMode('select')
			},
			{
				timeout: 5000,
				maximumAge: 0,
				enableHighAccuracy: true
			}
		);
	}

	render() {

		const {
			description,
			sex,
			skinColor,
			hairColor,
			age,
			weight,
			height,
			includeWeight,
			includeHeight,
			confirmState,
			disablePrev,
			comp,
		} = this.state;

		const { setActionMode, job, location } = this.props;
		const { streetNumber, streetName, subunit, city, state, zip } = location;

		const addressNorm = streetNumber ? 
			`${ streetNumber } ${ streetName }` : '';

		const settings = {
			speed: 300,
			easing: 'linear',
			className: l.reactSlider,
			afterChange: idx => {
				const disablePrev = idx === 0;
				let confirmState = false;

				if (idx === 7) {
					this.compVals();
					confirmState = true;
				}

				this.setState({ disablePrev, confirmState });
			},
		};

		return (
			<>
				<div className={ l.formHeader }>
					<span className={ l.title }>Bad Address</span>
					<span className={ l.cancel } onClick={ () => setActionMode('select') } >
						<FontAwesomeIcon icon='times' color='#fff'/>
					</span>
				</div>
				<div className={ l.column }>
					<RecipientSection job={ job } />
					<div className={ l.slideCont }>
						<Slider ref={ slider => (this.slider = slider) } { ...settings } >
							<div className={ l.fieldRow }>
								<Creatable
									isMulti
									placeholder='Description'
									onChange={ this.handleDescriptionChange }
									options={ description.options }
									value={ description.value }
									menuIsOpen={ true }
								/>
							</div>
							<div className={ l.fieldRow }>
								<div className={ l.sex }>
									<div className={ l.btnCont }>
										<button
											onClick={ () => this.setSex('Male') }
											style={{
												borderColor: (sex === 'Male' ? '#2686d8' : '#aaa'),
												borderWidth: (sex === 'Male' ? '2px' : '1px'),
											}}
										>
											<div>
												<FontAwesomeIcon
													icon='mars'
													size='4x'
													color={ (sex === 'Male' ? '#2686d8' : '#777') }
												/>
											</div>
											<div><label className={ l.sex }>Male</label></div>
										</button>
									</div>
									<div className={ l.btnCont }>
										<button
											onClick={ () => this.setSex('Female') }
											style={{
												borderColor: (sex === 'Female' ? '#2686d8' : '#aaa'),
												borderWidth: (sex === 'Female' ? '2px' : '1px'),
											}}
										>
											<div>
												<FontAwesomeIcon
													icon='venus'
													size='4x'
													color={ (sex === 'Female' ? '#2686d8' : '#777') }
												/>
											</div>
											<div><label className={ l.sex }>Female</label></div>
										</button>
									</div>
								</div>
							</div>
							<div className={ l.fieldRow }>
								<Select
									placeholder='Skin Color'
									onChange={ this.handleSkinColorChange }
									options={ skinColor.options }
									value={ skinColor.value }
									isClearable={ true }
									menuIsOpen={ true }
								/>
							</div>
							<div className={ l.fieldRow }>
								<Creatable
									placeholder='Hair Color'
									onChange={ this.handleHairColorChange }
									options={ hairColor.options }
									value={ hairColor.value }
									isClearable={ true }
									menuIsOpen={ true }
								/>
							</div>
							<div className={ l.fieldRow }>
								<Creatable
									placeholder='Age'
									onChange={ this.handleAgeChange }
									options={ age.options }
									value={ age.value }
									isClearable={ true }
									menuIsOpen={ true }
								/>
							</div>
							<div className={ l.fieldRow }>
								<label>Height (Ft./In.)</label>
								<div className={ l.fieldRow }>
									<div className={ l.includeToggle }>
										<input
											type='checkbox'
											checked={ includeHeight }
											onChange={ this.toggleHeightInclude }
										/>
									</div>
									<div className={ l.heightFeet }>
										<Select
											onChange={ this.handleHeightFeetChange }
											options={ height.feet.options }
											value={ height.feet.value }
											isClearable={ false }
											disabled={ !includeHeight }
											menuIsOpen={ true }
										/>
									</div>
									<div className={ l.heightInches }>
										<Select
											onChange={ this.handleHeightInchesChange }
											options={ height.inches.options }
											value={ height.inches.value }
											isClearable={ false }
											disabled={ !includeHeight }
											menuIsOpen={ true }
										/>
									</div>
								</div>
							</div>
							<div className={ l.fieldRow }>
								<label>Weight (Lbs.)</label>
								<div className={ l.fieldRow }>
									<div className={ l.includeToggle }>
										<input
											type='checkbox'
											checked={ includeWeight }
											onChange={ this.toggleWeightInclude }
										/>
									</div>
									<div className={ lx('formCell', 'weightHun') }>
										<Select
											onChange={ this.handleWeightHunChange }
											options={ weight.hun.options }
											value={ weight.hun.value }
											isClearable={ false }
											disabled={ !includeWeight }
											menuIsOpen={ true }
										/>
									</div>
									<div className={ lx('formCell', 'weightTen') }>
										<Select
											onChange={ this.handleWeightTenChange }
											options={ weight.ten.options }
											value={ weight.ten.value }
											isClearable={ false }
											disabled={ !includeWeight }
											menuIsOpen={ true }
										/>
									</div>
								</div>
							</div>
							<div className={ lx('fieldRow', 'badAddressPreview') }>
								<label>Details</label>
								<div>
									<BadAddressDetails { ...comp } />
								</div>
							</div>
						</Slider>
					</div>
					<div className={ l.formCtlBtns }>
						<div>
							<button
								className={ lx('prevBtn', { disabled: disablePrev }) }
								disabled={ disablePrev }
								onClick={ () => this.slider.slickPrev() }
							>
								<FontAwesomeIcon icon='arrow-left' color='#777'/>
							</button>
						</div>
						<div className={ l.badAddressCell }>
							<button
								className={ lx('badAddressBtn', { hide: !confirmState }) }
								onClick={ this.handleApplyBadAddressClick }
							>
								Apply
							</button>
						</div>
						<div>
							<button
								className={ lx('nextBtn', { disabled: confirmState }) }
								disabled={ confirmState }
								onClick={ () => this.slider.slickNext() }
							>
								<FontAwesomeIcon icon='arrow-right' color='#777'/>
							</button>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default connect(
	(state, props) => ({
		date: appSelectors.getPageDate(state, props),
		jobId: appSelectors.getPageJobId(state, props),
		username: usersSelectors.getUsername(state, props),
		location: locationsSelectors.getPageLocation(state, props),
	}),
	{
		setActionMode: appOperations.setActionMode,
		postCompleteTask: ordersOperations.postCompleteTask,
	}
)(BadAddress);
